import { Button } from '@material-ui/core';
import YoutubeEmbed from 'components/Shared/YoutubeEmbed';
import { WithStyles } from 'decorators/withStyles';
import { ICoupon, IExitPopUp } from 'interfaces/IExitPopUp';
import React, { Component, Fragment } from 'react';

interface IProps {
  exitPopUp: IExitPopUp;
  coupon?: ICoupon;
  classes?: any;
}

interface IState {}

@WithStyles(() => ({
  drawerPaper: {
    width: 'calc(100% - 448px)',
    backgroundColor: '#2C2C2C',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 16
  },

  exitPopUpContainer: {
    backgroundColor: '#fff',
    width: 600,
    maxHeight: '630px'
  },

  title: {
    padding: '24px 24px 5px 24px',
    width: '100%',
    height: 100,
    textAlign: 'center',
    backgroundColor: '#bdf1fa',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },

  img: {
    width: '100%',
    height: '100%',
    minHeight: 406
  },

  imgDiv: {
    height: '450px',
    minWidth: '600px',
    display: 'flex'
  },

  button: {
    minHeight: 80,
    width: '100%',
    backgroundColor: '#0670cc',
    borderRadius: 0
  },

  closeButton: {
    position: 'absolute',
    marginLeft: 555,
    top: 52,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  }
}))
export default class ExitPopUpComponent extends Component<IProps, IState> {
  render() {
    const { classes, exitPopUp } = this.props;
    const { button, timer, media } = exitPopUp;

    return (
      <Fragment>
        <style>
          {`.background-button {
                background-color: #${button.theme.backgroundColor};
                color: #${button.theme.textColor};
                font-size: ${button.theme.textSize}px;
              }
            .background-button:hover {
              background-color: #${button.theme.backgroundColorHover};
            }

            .background-header {
              background-color: #${timer.theme.backgroundColor};
            }

            .title {
              font-size: ${timer.theme.titleSize}px;
              color: #${timer.theme.titleColor};
            }

            .timer {
              color: #${timer.theme.titleColor};
              font-size: 22.5px;
            }
            `}
        </style>
        <div className={classes.drawerPaper}>
          <div className={classes.exitPopUpContainer}>
            <div className={`${classes.title} background-header`}>
              <span className={'title'}>{timer.theme.title}</span>
              {timer.enabled ? <div className={`timer`}>{`${('0' + timer.time).slice(-2)} : 00`}</div> : null}
            </div>
            <div className={classes.imgDiv}>
              {media.video ? (
                <YoutubeEmbed url={media.video} />
              ) : (
                media.image && (
                  <img
                    className={classes.img}
                    src={media.image.startsWith('data:') ? media.image : `https://cdn.eduzzcdn.com${media.image}`}
                  />
                )
              )}
            </div>
            {exitPopUp.button.enabled && (
              <Button id="chk-exitpopup-button" className={`${classes.button} background-button`}>
                {exitPopUp.button.theme.text}
              </Button>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
